import moment from 'jalali-moment';

export const convertTimeAgo = (timeString: string | null) => {
  if (timeString) {
    const today = new Date();
    const dateTime = moment(moment(new Date(timeString)))
      .locale('fa')
      .from(today);

    return dateTime;
  } else {
    return '';
  }
};
